import {IAppActions} from "../../types/IAppActions";
import {
  SET_WHATSAPP_RESTAURANT_STATE,
  SET_WHATSAPP_RESET_IS_LOADING,
  SET_WHATSAPP_IS_LOADING,
  SET_TG_RESTAURANT_STATE,
  SET_TG_RESET_IS_LOADING,
  SET_TG_PHONE_IS_LOADING,
  SET_TG_CODE_IS_LOADING,
  SET_TG_PASSWORD_IS_LOADING,
} from "./GuestmeNotificationsActionsTypes";

export function setWhatsappResetIsLoading(payload: boolean): IAppActions {
  return {
    type: SET_WHATSAPP_RESET_IS_LOADING,
    payload,
  };
}

export function setWhatsappIsLoading(payload: boolean): IAppActions {
  return {
    type: SET_WHATSAPP_IS_LOADING,
    payload,
  };
}

export function setTgResetIsLoading(payload: boolean): IAppActions {
  return {
    type: SET_TG_RESET_IS_LOADING,
    payload,
  };
}

export function setTgPhoneIsLoading(payload: boolean): IAppActions {
  return {
    type: SET_TG_PHONE_IS_LOADING,
    payload,
  };
}

export function setTgCodeIsLoading(payload: boolean): IAppActions {
  return {
    type: SET_TG_CODE_IS_LOADING,
    payload,
  };
}

export function setTgPasswordIsLoading(payload: boolean): IAppActions {
  return {
    type: SET_TG_PASSWORD_IS_LOADING,
    payload,
  };
}

export function setRestaurantWhatsappState(
  payload: GM.GuestmeNotifications.Response.WhatsappState,
): IAppActions {
  return {
    type: SET_WHATSAPP_RESTAURANT_STATE,
    payload,
  };
}

export function setRestaurantTgState(
  payload: GM.GuestmeNotifications.Response.TgState,
): IAppActions {
  return {
    type: SET_TG_RESTAURANT_STATE,
    payload,
  };
}
